import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ExpenseDetailsReportService } from './expense-details-report.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TerminalService } from 'src/app/pages/common/system/terminal/terminal.service';
import { AppConstants } from 'src/app/common/app.constants';
import { UserInfoModel } from 'src/app/common/models/user-info.model';
import moment from 'moment';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-expense-details-report',
  standalone: false,
  templateUrl: './expense-details-report.component.html',
  styleUrl: './expense-details-report.component.scss'
})
export class ExpenseDetailsReportComponent {
  user: UserInfoModel | undefined;

  title: string = "Expense Details";
  IsDownloading: boolean = false;

  editForm: FormGroup;
  cashierListData: any = [];
  expenseTypeList: any = [];

  shop_id: any;
  shop_name: any;
  terminalValidationMessage: any;
  cashierValidationMessage: any;
  expenseTypeValidationMessage: string = '';
  expenseTypeSelectionInvalid: boolean = false;
  cashierSelectionInvalid: boolean = false;
  isExpandedExpense = false;
  isExpandedCashier = false;
  showSelectedExpenseTypeOnly: boolean = false;
  showSelectedCashierOnly: boolean = false;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private expenseDetailsReportService: ExpenseDetailsReportService,
    private snackBarService: SnackBarService,
    private terminalService: TerminalService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {
    const today = new Date();
    this.editForm = this.builder.group({
      period_from: this.builder.control(today, Validators.required),
      period_to: this.builder.control(today, Validators.required),
      expenseTypeFilter: [''],
      cashierFilter: [''],
    });
  }


  ngOnInit(): void {

    this.expenseList();
    this.cashierList();
    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = (sesUser !== null) ? JSON.parse(sesUser) : undefined;
    this.permission = this.permissionService.getPagePermission("expense-details-report");
    console.log(this.permission);


  }
  permission: any;
  toggleContent(divData: string): void {
    if (divData == "expensetype") {
      this.isExpandedExpense = !this.isExpandedExpense;
    }
    if (divData == "cashier") {
      this.isExpandedCashier = !this.isExpandedCashier;
    }
  }




  /**
    * Get expense type list
    */
  expenseList(): void {

    let requestData = {
      search: {

        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 1000,
            offset: 0
          }
        },
        sort: [
          {
            column: "name",
            order: "asc"
          }
        ]

      }
    }

    this.expenseDetailsReportService.getExpenseTypeList(requestData).subscribe(
      (response: any) => {
        this.expenseTypeList = [];
        var index = 0;
        response.data.expenseTypes.forEach((item: any) => {

          var data = { index: index, item: item, selected: false };
          this.expenseTypeList.push(data);
          index++;
        });

      },
      (error: any) => {

      },
    );
  }

  /**
   * Get cashier list
   */
  cashierList(): void {
    this.expenseDetailsReportService.getUsers().subscribe(
      (response: any) => {
        this.cashierListData = [];
        var index = 0;
        response.data.users.forEach((item: any) => {

          var data = { index: index, item: item, selected: false };
          this.cashierListData.push(data);
          index++;
        });

      },
      (error: any) => {

      },
    );

  }




  onListSelectionChange(selectionData: any): void {

  }

  /**
    * Export expense detail report
    */

  exportClicked(): void {
    const from = this.editForm.get("period_from")?.value;
    const to = this.editForm.get("period_to")?.value;
    if (from && to) {
      const fromDate = new Date(from);
      const toDate = new Date(to);
      const diff = (toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24);
      if (diff >= 365) {
        this.snackBarService.openSnackBar({
          message: "Please choose a date range shorter than 365 days.",
          type: "warn"
        } as SnackBarData);
        return;
      }
    }
    if (this.editForm.valid) {
      const selectedCashierIds = this.cashierListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);

      const selectedExpenceTypeIds = this.expenseTypeList
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);

      const cashierIds = selectedCashierIds.length > 0 ? selectedCashierIds : [];
      const expenseIds = selectedExpenceTypeIds.length > 0 ? selectedExpenceTypeIds : [];
      var rawDateFrom = this.editForm.get('period_from')?.value;
      var formattedDateFrom = moment(rawDateFrom).format('DD-MM-YYYY');
      var rawDateTo = this.editForm.get('period_to')?.value;
      var formattedDateTo = moment(rawDateTo).format('DD-MM-YYYY');

      // Create the data object
      if (this.user?.shop_info !== null && this.user?.shop_info !== undefined) {
        this.shop_id = this.user?.shop_info.id;
        this.shop_name = this.user?.shop_info.name;
      }
      const reportData = {
        shopId: this.shop_id,
        shopName: this.shop_name,
        dateFrom: formattedDateFrom,
        dateTo: formattedDateTo,
        expenseTypeFrom: expenseIds,
        cashierFrom: cashierIds,
        isExport: 1
      };
      this.IsDownloading = true;
      if (reportData) {
        this.expenseDetailsReportService.exportExpenseDetailsReport(reportData).subscribe({
          next: (response) => {
            // Handle "No data found" by checking if the response is JSON with status 'NO_DATA_FOUND'
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const text = reader.result as string;
                const json = JSON.parse(text);
                if (json.status === 'NO_DATA_FOUND') {
                  let snackBarData: SnackBarData = {
                    message: 'No data found.',
                    title: 'No Data!!!',
                    type: 'warn'
                  }
                  this.IsDownloading = false;
                  this.snackBarService.openSnackBar(snackBarData);
                  return;
                }
              } catch (e) {
                // Not JSON, treat as file
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'expense-details-report.xlsx';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                this.IsDownloading = false;
              }
            };
            reader.readAsText(response);
          },
          error: (error) => {
            this.IsDownloading = false;
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    } else {
      this.editForm.markAllAsTouched();
    }
  }

  // Select All and Reset
  // --- Expense Type Logic ---
  toggleSelectAllExpenseType() {
    const allSelected = this.expenseTypeList.every((item: any) => item.selected);
    this.expenseTypeList.forEach((item: any) => (item.selected = !allSelected));
  }

  getSelectAllIconExpenseType(): string {
    const allSelected = this.expenseTypeList.every((item: any) => item.selected);
    const someSelected = this.expenseTypeList.some((item: any) => item.selected);

    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  get filteredExpenseTypeList() {
    let filteredList = this.expenseTypeList;
    if (this.showSelectedExpenseTypeOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('expenseTypeFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  get selectedExpenseTypeCount(): number {
    return this.expenseTypeList?.filter((item: any) => item.selected)?.length || 0;
  }

  // --- Cashier Logic ---
  toggleSelectAllCashier() {
    const allSelected = this.cashierListData.every((item: any) => item.selected);
    this.cashierListData.forEach((item: any) => (item.selected = !allSelected));
  }

  getSelectAllIconCashier(): string {
    const allSelected = this.cashierListData.every((item: any) => item.selected);
    const someSelected = this.cashierListData.some((item: any) => item.selected);

    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  get filteredCashierListData() {
    let filteredList = this.cashierListData;
    if (this.showSelectedCashierOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('cashierFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  get selectedCashierCount(): number {
    return this.cashierListData?.filter((item: any) => item.selected)?.length || 0;
  }
}
